// Gems Mine — the believability ticker. FIREWALLED like roulette's fake layer:
// this module knows nothing about money, imports nothing from the engine, and
// its output is display-only strings. A fake cashout can never be one concat
// away from a real one because it never exists as a number in the money path.

const NAMES = [
  'Ravi', 'Priya', 'Manish', 'Farhan', 'Amrutha', 'Vikram', 'Sana', 'Deepak',
  'Kavya', 'Arjun', 'Neha', 'Rohit', 'Ishaan', 'Pooja', 'Salman', 'Anita',
];

const mask = (n: string) => n.slice(0, 2) + '**' + n.slice(-1);

/** A plausible cashout line. Amounts follow a lumpy distribution — mostly
 *  small, occasionally a shout — because a feed of round numbers is a tell. */
function line(rnd: () => number): string {
  const name = mask(NAMES[Math.floor(rnd() * NAMES.length)]);
  const r = rnd();
  const amt = r < 0.55
    ? 20 + Math.floor(rnd() * 480)
    : r < 0.88
      ? 500 + Math.floor(rnd() * 2500)
      : 3000 + Math.floor(rnd() * 22000);
  const x = (1.1 + rnd() * (r < 0.88 ? 3 : 14)).toFixed(2).replace(/0$/, '');
  return `${name} dug out ₹${amt.toLocaleString('en-IN')} · X${x}`;
}

/** A batch for the ticker. The track renders it twice and scrolls -50%, so the
 *  loop is seamless by construction. */
export function tickerBatch(count = 9): string[] {
  const out: string[] = [];
  for (let i = 0; i < count; i++) out.push(line(Math.random));
  return out;
}
